import { DocsAnalyticsTimeFrame } from "./SDKDocsAnalyticsTimeFrame";
export class DocsAnalyticsComparisonData {
    constructor(model) {
        this.timeFrame = new DocsAnalyticsTimeFrame(model.timeFrame);
        this.currentVisitCount = model.currentVisitCount;
        this.priorVisitCount = model.priorVisitCount;
        this.currentSessionCount = model.currentSessionCount;
        this.priorSessionCount = model.priorSessionCount;
    }
}
